import { combineReducers } from 'redux';

import actions from 'containers/assets/reducers_actions';
import list from 'containers/assets/reducers_list';
import form from 'containers/assets/reducers_form';
import historics from 'containers/assets/reducers_historics';

export default combineReducers({ list, form, actions, historics });



// WEBPACK FOOTER //
// src/containers/assets/reducers.js